



















import Vue from "vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  name: "InvoiceList",
  data() {
    return {
      columns: [
        {
          title: "Date",
          key: "created",
          align: "center",
          render: (h, params) => {
            let dateString = moment(params.row.created).format("MMM D, YYYY");
            return h(
              "div",
              params.row.hosted_invoice_url
                ? [
                    h(
                      "a",
                      {
                        attrs: {
                          href: params.row.hosted_invoice_url,
                          target: "_blank",
                        },
                      },
                      dateString
                    ),
                  ]
                : [dateString]
            );
          },
        },
        {
          title: "Total",
          key: "total",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.total >= 0 ? `$${params.row.total / 100}` : `($${-params.row.total / 100})`);
          },
        },
        {
          title: "Status",
          key: "status",
          align: "center",
          render: (h, params) => {
            return h("span", [
              h("Badge", {
                attrs: {
                  type: params.row.status === "draft" ? "info" : params.row.status === "paid" ? "success" : "error",
                  text: params.row.status === "draft" ? "next" : params.row.status,
                },
                style: { "margin-left": "8px" },
              }),
            ]);
          },
        },
        {
          title: "Download",
          key: "invoice_pdf",
          align: "center",
          className: "hidden-lg-down",
          render: (h, params) => {
            return h(
              "div",
              params.row.invoice_pdf
                ? [
                    h(
                      "a",
                      {
                        attrs: {
                          href: params.row.invoice_pdf,
                          target: "_blank",
                        },
                      },
                      "Download PDF"
                    ),
                  ]
                : []
            );
          },
        },
        {
          title: "Number",
          key: "number",
          width: 140,
          render: (h, params) => {
            return h(
              "div",
              params.row.hosted_invoice_url
                ? [
                    h(
                      "a",
                      {
                        attrs: {
                          href: params.row.hosted_invoice_url,
                          target: "_blank",
                        },
                      },
                      params.row.number
                    ),
                  ]
                : [params.row.number]
            );
          },
        },
      ],
      invoices: [],
    };
  },
  computed: {
    ...mapState("billing", ["loading", "billingAccount"]),
    billingAccountNextChargeDate() {
      let context = this as any;
      return context.billingAccount.currentPlanEndDate ? moment(context.billingAccount.currentPlanEndDate).format("L") : "";
    },
  },
  watch: {},
  mounted() {
    this.loadInvoices();
  },
  methods: {
    loadInvoices() {
      this.$store
        .dispatch("billing/getInvoices")
        .then((response) => {
          this.invoices = response.data.result.invoices.data;
        })
        .finally(() => {});
    },
  },
});
